// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as DownloadAppsBanner__AppBadge$PrezzeeRibbon from "./DownloadAppsBanner__AppBadge.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(1.375)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(1.125))]),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("row")
    ]);

var Styles = {
  container: container
};

function DownloadAppsBanner__AppBadges(props) {
  var badges = React.Children.toArray(props.children);
  var individualBadges = Belt_Array.mapWithIndex(badges, (function (idx, item) {
          return JsxRuntime.jsx(DownloadAppsBanner__AppBadge$PrezzeeRibbon.make, {
                      children: item
                    }, String(idx));
        }));
  return JsxRuntime.jsx("div", {
              children: individualBadges,
              className: container
            });
}

var Badge;

var make = DownloadAppsBanner__AppBadges;

export {
  Badge ,
  Styles ,
  make ,
}
/* container Not a pure module */
